<template>
    <v-container>
        <h1>Rosters</h1>
        
        <div class="typography" v-if="this.$store.state.status === 'fetch_success'">

        <h3>Fall 2022 Registration Fees and Dates</h3>
        <p>General Registration (Monday, September 12, 2022 through Friday, October 21, 2022): <strong>$390 per course</strong></p>
        <p>Late Registration (Saturday, October 22, 2022 through Friday, January 13, 2023): <strong>$425 ($390 + $35 late fee)</strong></p>

        <p>Select the course number below to view the students enrolled in the course.</p>
        <div class="table_wrapper">
            <div class="table_wrapper_inner" v-for="term in this.sortedRosters" v-bind:key="term.term_code">
                <h3>{{ term[0].term }}</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Course Name</th>
                            <th>Course Number</th>
                            <th>Instructor</th>
                            <th>Credits</th>
                            <th>Course Roster</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="course in term" v-bind:key="course.course_id">
                            <td width="40%">{{ course.title }}</td>
                            <td width="15%"><router-link :to="{ path: '/roster/'+course.term_code.replace('/', '*')+'-'+course.course_id }">{{ course.course_id }}</router-link></td>
                            <td width="20%">{{ course.instructor }}</td>
                            <td width="10%">{{ course.credits }}</td>
                            <td width="15%" align="right"><!--<button class="secondary-button">Syllabus</button>--><router-link :to="{ path: '/roster/'+course.term_code.replace('/', '*')+'-'+course.course_id}" class="secondary-button">Roster</router-link></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
        <div v-else>
            <v-skeleton-loader
            class="mx-auto"
            type="table-body, table-row-divider@6"
            ></v-skeleton-loader>
        </div>
    </v-container>
</template>
<script>


export default {
    props: {
        // terms: [],
        sections: []
    },

    data: () => ({
        sortedRosters: []
    }),

    computed: {
        terms: function() {
            return this.$store.getters.terms
        },
        course_rosters: function() {
            return this.$store.getters.course_rosters
        },
        user_id: function() {
            return this.$store.getters.user_id
        },
        all_instructor_ids: function() {
            return this.$store.getters.all_instructor_ids
        }
    },

    mounted() {
        this.course_rosters
        let self = this
        this.$store.dispatch('fetchInstructorRoster')
        .then((resp) => {
            window.console.log("DEETS: "+resp)
            self.sortedRosters = this.sortRoster(this.course_rosters, 'term_code')
        })
        .catch((err) => {
            window.console.error('Handling expired session ' + err)
            this.$store.dispatch('handleExpiredSession')
        })
    },

    methods: {
        sortRoster: function(xs, key) {
            return xs.reduceRight(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        }
    }
}
</script>
